import { forwardRef, type CSSProperties } from 'react';
import styles from './IconsLib.module.css';
import { ReactComponent as OfflineImage } from '../../../assets/icons/offline.svg';
import { ReactComponent as SearchImage } from '../../../assets/icons/search.svg';
import { ReactComponent as MobileSearchImage } from '../../../assets/icons/mobile-search.svg';
import { ReactComponent as AppsImage } from '../../../assets/icons/mobile-app.svg';
import { ReactComponent as HomeImage } from '../../../assets/icons/mobile-home.svg';
import { ReactComponent as MessageImage } from '../../../assets/icons/mobile-message.svg';
import { ReactComponent as ProfileImage } from '../../../assets/icons/mobile-profile.svg';
import { ReactComponent as CloseImage } from '../../../assets/icons/close.svg';
import { ReactComponent as IconActivity } from '../../../assets/icons/icon-activity.svg';
import { ReactComponent as IconActivityBlue } from '../../../assets/icons/icon-activity-blue.svg';
import { ReactComponent as IconClient } from '../../../assets/icons/icon-client.svg';
import { ReactComponent as IconClientBlue } from '../../../assets/icons/icon_client_blue.svg';
import { ReactComponent as IconEmpty } from '../../../assets/icons/icon-empty.svg';
import { ReactComponent as IconFinder } from '../../../assets/icons/icon-finder.svg';
import { ReactComponent as IconProject } from '../../../assets/icons/icon-project.svg';
import { ReactComponent as IconProjectBlue } from '../../../assets/icons/icon_project_blue.svg';
import { ReactComponent as EmptyImage } from '../../../assets/icons/empty.svg';
import { ReactComponent as AllVacancies } from '../../../assets/icons/all_vacancies.svg';
import { ReactComponent as MyVacancies } from '../../../assets/icons/my_vacancies.svg';
import { ReactComponent as IconArrowDetail } from '../../../assets/icons/icon-arrrow-detail.svg';
import { ReactComponent as IconContact } from '../../../assets/icons/icon-contacts.svg';
import { ReactComponent as IconContactUnknown } from '../../../assets/icons/icon_contact_unknown.svg';
import { ReactComponent as SearchUser } from '../../../assets/icons/search_user.svg';
import { ReactComponent as RightArrow } from '../../../assets/icons/icon-right-arrow.svg';
import { ReactComponent as IconAtollon } from '../../../assets/icons/icon_atollon.svg';
import { ReactComponent as IconPrint } from '../../../assets/icons/icon_print.svg';
import { ReactComponent as IconEdit } from '../../../assets/icons/icon_edit.svg';
import { ReactComponent as IconCopy } from '../../../assets/icons/icon_copy.svg';
import { ReactComponent as IconTool } from '../../../assets/icons/icon_tool.svg';
import { ReactComponent as IconTrash } from '../../../assets/icons/icon_trash.svg';
import { ReactComponent as IconMore } from '../../../assets/icons/icon_more.svg';
import { ReactComponent as IconLinkdin } from '../../../assets/icons/icon_linkdin.svg';
import { ReactComponent as IconFacecook } from '../../../assets/icons/icon_facebook.svg';
import { ReactComponent as IconTwitter } from '../../../assets/icons/icon_twitter.svg';
import { ReactComponent as IconMassmailGreen } from '../../../assets/icons/icon_massmail_green.svg';
import { ReactComponent as IconMassmailRed } from '../../../assets/icons/icon_massmail_red.svg';
import { ReactComponent as IconAlert } from '../../../assets/icons/icon_alert.svg';
import { ReactComponent as IconAlertFill } from '../../../assets/icons/icon_alert_fill.svg';
import { ReactComponent as IconTable } from '../../../assets/icons/icon_table.svg';
import { ReactComponent as IconCard } from '../../../assets/icons/icon_card.svg';
import { ReactComponent as IconFilter } from '../../../assets/icons/icon_filter.svg';
import { ReactComponent as IconEventTaskFuture } from '../../../assets/icons/icon_event_future.svg';
import { ReactComponent as IconEventTaskCompleted } from '../../../assets/icons/icon_task _event_completed.svg';
import { ReactComponent as IconEventTaskUncompleted } from '../../../assets/icons/icon_task_event_uncompleted.svg';

import { ReactComponent as IconMailOutComming } from '../../../assets/icons/icon_mail_outcomming.svg';
import { ReactComponent as IconMailInComming } from '../../../assets/icons/icon_mail_incomming.svg';
import { ReactComponent as IconPhoneInComing } from '../../../assets/icons/icon_phone_incoming.svg';
import { ReactComponent as IconPhoneOurGoing } from '../../../assets/icons/icon_phone_outgoing.svg';
import { ReactComponent as IconPhoneMissed } from '../../../assets/icons/icon_phone_missed.svg';
import { ReactComponent as IconNotice } from '../../../assets/icons/icon_notice.svg';
import { ReactComponent as IconCalendar } from '../../../assets/icons/icon_calendar.svg';
import { ReactComponent as IconInvoice } from '../../../assets/icons/icon_invoice.svg';
import { ReactComponent as IconTask } from '../../../assets/icons/icon_task.svg';
import { ReactComponent as IconDocument } from '../../../assets/icons/icon_document.svg';
import { ReactComponent as IconReply } from '../../../assets/icons/icon_reply.svg';
import { ReactComponent as IconReplyAll } from '../../../assets/icons/icon_reply_all.svg';
import { ReactComponent as IconArrowForward } from '../../../assets/icons/icon_arrow_forward.svg';
import { ReactComponent as IconArrowLeft } from '../../../assets/icons/icon_arrow_left.svg';
import { ReactComponent as IconAttachment } from '../../../assets/icons/icon_attachment.svg';
import { ReactComponent as IconCancel } from '../../../assets/icons/icon_cancel.svg';
import { ReactComponent as IconPhone } from '../../../assets/icons/icon_phone.svg';
import { ReactComponent as IconGlobe } from '../../../assets/icons/globe_grid.svg';
import { ReactComponent as IconSend } from '../../../assets/icons/send.svg';
import { ReactComponent as IconAIChat } from '../../../assets/icons/icon_ai_chat.svg';
import { ReactComponent as IconAIChatColored } from '../../../assets/icons/icon_ai_chat_colored.svg';
import { ReactComponent as IconAIChat2 } from '../../../assets/icons/icon_ai_chat_2.svg';
import { ReactComponent as IconNewMessage } from '../../../assets/icons/icon_new_message.svg';
import { ReactComponent as IconTemplate } from '../../../assets/icons/icon_template.svg';
import { ReactComponent as IconMyMessages } from '../../../assets/icons/icon_my_messages.svg';
import { ReactComponent as IconSent } from '../../../assets/icons/icon_sent.svg';
import { ReactComponent as IconDraft } from '../../../assets/icons/icon_draft.svg';
import { ReactComponent as IconFolder } from '../../../assets/icons/icon_folder.svg';
import { ReactComponent as IconComment } from '../../../assets/icons/icon_comment.svg';
import { ReactComponent as IconLock } from '../../../assets/icons/icon_lock.svg';
import { ReactComponent as IconCheckGreen } from '../../../assets/icons/icon_check_green.svg';
import { ReactComponent as IconCancelRed } from '../../../assets/icons/icon_cancel_red.svg';
import { ReactComponent as IconArrowLongRight } from '../../../assets/icons/icon_arrowlong_right.svg';
import { ReactComponent as IconArrowLongLeft } from '../../../assets/icons/icon_arrowlong_left.svg';
import { ReactComponent as IconMaximize } from '../../../assets/icons/icon_maximize.svg';

export enum IconStyle {
  none = '',
  filtered = 'filtered',
  normal = 'normal',
}
type IconType = {
  size: number;
  height?: number;
  color?: string;
  stateClass?: IconStyle;
};

const _getIconStyle = (stateClass?: IconStyle) => {
  switch (stateClass) {
    case IconStyle.filtered:
      return styles.filtered;
    case IconStyle.normal:
      return styles.normal;
    default:
      return '';
  }
};
export const ActivityIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconActivity width={size} height={size} />
    </div>
  );
};

export const ActivityIconBlue = ({ size }: IconType) => {
  return (
    <div>
      <IconActivityBlue width={size} />
    </div>
  );
};

export const ClientIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconClient width={size} height={size} />
    </div>
  );
};

export const ClientIconBlue = ({ size }: IconType) => {
  return (
    <div>
      <IconClientBlue width={size} height={size} />
    </div>
  );
};

export const EmptyIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconEmpty width={size} height={size} />
    </div>
  );
};

export const FinderIcon = forwardRef<HTMLDivElement, IconType>(({ size, color }, ref) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
    '--finder-icon-color': color
  } as CSSProperties & { '--finder-icon-color': string | undefined };
  return (
    <div ref={ref} style={iconStyle} className={styles.finderIcon}>
      <IconFinder width={size} height={size} />
    </div>
  );
});
FinderIcon.displayName = 'FinderIcon';

export const ProjectIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconProject width={size} height={size} />
    </div>
  );
};

export const ProjectIconBlue = ({ size }: IconType) => {
  return (
    <div>
      <IconProjectBlue width={size} height={size} />
    </div>
  );
};

export const OfflineIcon = ({ size }: IconType) => {
  const iconStyle = {
    backgroundColor: '#FEE8E6',
    borderRadius: '50%',
    padding: '3px 3px 0px 3px',
  };
  return (
    <div style={iconStyle}>
      <OfflineImage width={size} height={size} />
    </div>
  );
};

export const SearchIcon = ({ size, stateClass }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <SearchImage width={size} height={size} className={_getIconStyle(stateClass)} />
    </div>
  );
};

export const MobileSearchIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <MobileSearchImage width={size} height={size} />
    </div>
  );
};

export const AppsIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <AppsImage width={size} height={size} />
    </div>
  );
};

export const HomeIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <HomeImage width={size} height={size} />
    </div>
  );
};

export const MessageIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <MessageImage width={size} height={size} />
    </div>
  );
};

export const ProfileIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <ProfileImage width={size} height={size} />
    </div>
  );
};

export const CloseIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <CloseImage width={size} height={size} />
    </div>
  );
};

export const EmptyIcon2 = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <EmptyImage width={size} height={size} />
    </div>
  );
};

export const AllVacanciesIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <AllVacancies width={size} height={size} />
    </div>
  );
};

export const MyVacanciesIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
  };
  return (
    <div style={iconStyle}>
      <MyVacancies width={size} height={size} />
    </div>
  );
};

export const ArrowDetailIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'contents',
  };
  return (
    <div style={iconStyle}>
      <IconArrowDetail width={size} height={size} />
    </div>
  );
};

export const ContactIcon = ({ size, color }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconContact color={color} width={size} height={size} />
    </div>
  );
};

export const ContactIconUnknown = ({ size, color }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconContactUnknown color={color} width={size} height={size} />
    </div>
  );
};

export const SearchUserIcon = ({ size, color }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <SearchUser color={color} width={size} height={size} />
    </div>
  );
};

export const RightArrowIcon = ({ size }: IconType) => {
  return (
    <div>
      <RightArrow width={size} />
    </div>
  );
};

export const AtollonIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconAtollon width={size} />
    </div>
  );
};

export const PrintIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconPrint width={size} />
    </div>
  );
};

export const EditIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconEdit width={size} />
    </div>
  );
};

export const CopyIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconCopy width={size} />
    </div>
  );
};

export const ToolIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconTool width={size} />
    </div>
  );
};

export const TrashIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconTrash width={size} />
    </div>
  );
};

export const MoreIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconMore width={size} />
    </div>
  );
};

export const LinkdinIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconLinkdin width={size} />
    </div>
  );
};
export const FacebookIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconFacecook width={size} />
    </div>
  );
};
export const TwitterIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconTwitter width={size} />
    </div>
  );
};

export const MassmailGreen = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconMassmailGreen width={size} />
    </div>
  );
};

export const MassmailRed = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconMassmailRed width={size} />
    </div>
  );
};

export const AlertIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconAlert width={size} />
    </div>
  );
};

export const AlertIconFill = ({ size }: IconType) => {
  return (
    <div>
      <IconAlertFill width={size} />
    </div>
  );
};

export const TableIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconTable width={size} />
    </div>
  );
};

export const CardIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconCard width={size} />
    </div>
  );
};

export const FilterIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconFilter width={size} />
    </div>
  );
};

export const EventTaskFutureIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconEventTaskFuture width={size} />
    </div>
  );
};

export const EventTaskCompletedIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconEventTaskCompleted width={size} />
    </div>
  );
};

export const EventTaskUncompletedIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconEventTaskUncompleted width={size} />
    </div>
  );
};

export const MailInCommingIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconMailInComming width={size} />
    </div>
  );
};

export const MailOutCommingIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconMailOutComming width={size} />
    </div>
  );
};

export const PhoneInComingIcon = ({ size, height }: IconType) => {
  return (
    <div>
      <IconPhoneInComing width={size} height={height} />
    </div>
  );
};

export const PhoneInOutGoingIcon = ({ size, height }: IconType) => {
  return (
    <div>
      <IconPhoneOurGoing width={size} height={height} />
    </div>
  );
};

export const PhoneMissedIcon = ({ size, height }: IconType) => {
  return (
    <div>
      <IconPhoneMissed width={size} height={height} />
    </div>
  );
};

export const NoticeIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconNotice width={size} />
    </div>
  );
};

export const CalendarIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconCalendar width={size} />
    </div>
  );
};

export const InvoiceIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconInvoice width={size} />
    </div>
  );
};

export const TaskIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconTask width={size} />
    </div>
  );
};

export const DocumentIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconDocument width={size} />
    </div>
  );
};

export const ReplyIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconReply width={size} />
    </div>
  );
};

export const ReplyAllIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconReplyAll width={size} />
    </div>
  );
};

export const ArrowForwardIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconArrowForward width={size} />
    </div>
  );
};
export const ArrowLeftIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconArrowLeft width={size} />
    </div>
  );
};

export const AttachmentIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconAttachment width={size} />
    </div>
  );
};

export const CancelIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconCancel width={size} />
    </div>
  );
};

export const PhoneIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconPhone width={size} />
    </div>
  );
};
export const GlobeIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconGlobe width={size} />
    </div>
  );
};
export const SendIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconSend width={size} />
    </div>
  );
};

export const NewMessageIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconNewMessage width={size} />
    </div>
  );
};

export const TemplateIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconTemplate width={size} />
    </div>
  );
};

export const MyMessagesIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconMyMessages width={size} />
    </div>
  );
};

export const SentIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconSent width={size} />
    </div>
  );
};

export const DraftIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconDraft width={size} />
    </div>
  );
};

export const FolderIcon = ({ size }: IconType) => {
  return (
    <div>
      <IconFolder width={size} />
    </div>
  );
};

export const AIChatIcon2 = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconAIChat2 width={size} />
    </div>
  );
};

export const AIChatIcon = ({ size, height }: IconType) => {

  return (
    <div>
      <IconAIChat width={size} height={height} />
    </div>
  );
};

export const AIChatIconColored = ({ size, height }: IconType) => {
  return (
    <div>
      <IconAIChatColored width={size} height={height} />
    </div>
  );
};

export const CommentIcon = ({ size, height }: IconType) => {
  return (
    <div>
      <IconComment width={size} height={height} className={styles.commentIcon} />
    </div>
  );
};
export const LockIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconLock width={size} />
    </div>
  );
};
export const CheckMarkGreenIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconCheckGreen width={size} />
    </div>
  );
};
export const CancelRedIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconCancelRed width={size} />
    </div>
  );
};
export const ArrowRightLongIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconArrowLongRight width={size} />
    </div>
  );
};

export const ArrowLeftLongIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconArrowLongLeft width={size} />
    </div>
  );
};

export const MaximizeIcon = ({ size }: IconType) => {
  const iconStyle = {
    cursor: 'pointer',
    display: 'inherit',
  };
  return (
    <div style={iconStyle}>
      <IconMaximize width={size} />
    </div>
  );
};
